import React from "react";
import { useState, useContext,useCallback, useEffect } from "react";
import { useLocation, Link } from "react-router-dom"; // 👈 Importamos Link
import { BiLogOutCircle } from "react-icons/bi";
import globo from "../img/globe_location_pin (1).svg";
import { MyContext } from "../context/Context";
import { precioPais } from "../controller/api";

export default function Header({ toggleModal, userTipo }) {
  const { isModalOpen } = useContext(MyContext);
  const [precio, setPrecio] = useState(null);
  const location = useLocation();
  const fetchPreciosPais = useCallback(async () => {
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      if (!user?.pais) return;

      const data = await precioPais(user.pais);
      const precioRedondeado = Math.ceil(data.hora_trabajo);

      setPrecio(precioRedondeado);
      localStorage.setItem("precio", JSON.stringify(precioRedondeado));
    } catch (error) {
      console.error("Error al obtener los precios por país:", error);
    }
  }, []);
  const handleLogout = () => {
    localStorage.clear();
    window.location.reload();
  };
  useEffect(() => {
    if (isModalOpen) {
      // Paso 1: al abrir el modal, resetear el precio a 1
      localStorage.setItem("precio", JSON.stringify(1));
      window.dispatchEvent(new Event("storage"));
      setPrecio(1);

      // Paso 2: luego cargar el precio real del usuario
      fetchPreciosPais();
    } else {
      // Si el modal se cierra, simplemente actualiza desde la API
      fetchPreciosPais();
    }
  }, [isModalOpen]);

  return (
    <div className="header">
      <div>
        {/* 👇 Usamos Link para navegar sin recarga */}
        <Link to="/">
          <img
            src="https://detipcompany.com/wp-content/uploads/2024/10/cropped-PropuestaLogo.png"
            alt="logo detip"
            className="imagen"
          />
        </Link>
      </div>
      <div className="boton-pais">
        {userTipo === 1 && (
          <a onClick={toggleModal}>
            País
            <img src={globo} alt="Globo de ubicación" />
          </a>
        )}
        <a onClick={handleLogout}>
          Cerrar sesión
          <BiLogOutCircle size={25} color="#FFFF" />
        </a>
      </div>
    </div>
  );
}
